import { GroceryStockThresholdInput } from '../types/StoreGroceryStock'

export const stockText = ({ inStockQuantity, restockedQuantity, runningOutThreshold }: { inStockQuantity: number, restockedQuantity: number, runningOutThreshold?: number | null }) => {
  if (inStockQuantity === 0) {
    return 'Slut'
  } else if (isStockBelowRatio({ inStockQuantity, restockedQuantity, runningOutThreshold })) {
    return 'Snart slut'
  }
}

export const isStockBelowRatio = ({ inStockQuantity, restockedQuantity, runningOutThreshold }: { inStockQuantity: number, restockedQuantity: number, runningOutThreshold?: number | null }) => {
  if (inStockQuantity === 0) {
    return true
  } else if (runningOutThreshold != null && runningOutThreshold > 0) {
    return inStockQuantity <= runningOutThreshold
  }
  return inStockQuantity <= ratio(restockedQuantity)
}

export const getRunningOutThreshold = (quantity: number) => {
  return ratio(quantity)
}

export const getEffectiveRunningOutThreshold = ({restockedQuantity, runningOutThreshold,}: {restockedQuantity: number, runningOutThreshold?: number | null}) => {
  return (runningOutThreshold != null && runningOutThreshold > 0) ? runningOutThreshold : getRunningOutThreshold(restockedQuantity)
}

export const compareRunningOutThreshold = (a: GroceryStockThresholdInput, b: GroceryStockThresholdInput, direction: 'asc' | 'desc' = 'asc'
) => {
  const aIsCustom = a.runningOutThreshold != null && a.runningOutThreshold > 0
  const bIsCustom = b.runningOutThreshold != null && b.runningOutThreshold > 0

  // Custom ("Ändrat") thresholds sort first on desc, last on asc
  if (aIsCustom !== bIsCustom) {
    return aIsCustom
      ? direction === 'desc' ? -1 : 1
      : direction === 'desc' ? 1 : -1
  }

  const resolvedThreshold = (item: GroceryStockThresholdInput) => getEffectiveRunningOutThreshold(item)
  const thresholdDiff = resolvedThreshold(a) - resolvedThreshold(b)
  return direction === 'asc' ? thresholdDiff : -thresholdDiff
}

const ratio = (restockedQuantity: number) => {
  const defaultRatio: number = 0.2
  const lesserRatio: number = 0.3

  return restockedQuantity >= 1 && restockedQuantity <= 5
    ? Math.ceil(restockedQuantity * lesserRatio)
    : Math.ceil(restockedQuantity * defaultRatio)
}

export const getRunningOutThresholdTooltip = (restockedQuantity: number, inStockQuantity: number = 0, maxQuantity?: number | null): string => {
  if (maxQuantity != null && maxQuantity > 0) {
    if (maxQuantity === 1 && inStockQuantity === 1) {
      return 'Artikeln visas som "Snart slut" om antal i skåp är 1 och maxsaldo är 1.'
    } else if (maxQuantity >= 1 && maxQuantity <= 5) {
      return '30 % av påfyllt antal (avrundat uppåt) — eftersom maxsaldo är mellan 1 och 5.'
    } else if (maxQuantity >= 6) {
      return '20 % av påfyllt antal (avrundat uppåt) — eftersom maxsaldo är 6 eller fler.'
    }
    return ''
  }

  if (restockedQuantity === 1 && inStockQuantity === 1) {
    return 'Artikeln visas som "Snart slut" om antal i skåp är 1 och senast påfyllt är 1.'
  } else if (restockedQuantity >= 1 && restockedQuantity <= 5) {
    return '30 % av påfyllt antal (avrundat uppåt) — eftersom påfyllt är mellan 1 och 5.'
  } else if (restockedQuantity >= 6) {
    return '20 % av påfyllt antal (avrundat uppåt) — eftersom påfyllt är 6 eller fler.'
  } else if (restockedQuantity === 0) {
    return 'För att beräkna gränsvärde behöver det senaste påfyllda saldot vara minst 1.'
  }
  return ''
}
